import { put, takeLatest, call, select, all } from "redux-saga/effects"
import {
	displayNamesRequest,
	displayNamesSuccess,
	displayNamesFailure,
	filteredDisplayNamesFailure,
	filteredDisplayNamesRequest,
	filteredDisplayNamesSuccess
} from "../actions/displayNames"
import {
	getDisplayNames,
	getFilterDisplayNamesApi,
	getIngredientsCount,
	rustyDisplayNames,
} from "src/services/common/master"
import jwtManager from "src/utils/jwtManager"

const PAGE_SIZE = 500


function* displayNamesSaga(action: any): Generator<any, any, any> {
	const inputs = action.payload?.inputs
	const lang: string = yield select((state) => state.language.current)
	const { defaultHeaders } = yield select((state) => state)
	const headers = { ...defaultHeaders, token: jwtManager.getToken() }
	let resultData: any = {}
	let ingredientsStatus = true

	try {
		const { data: { result: { data, status } } } = yield call(
			getDisplayNames,
			{
				...action.payload,
				inputs: !!inputs?.length ? inputs : [
					"processing",
					"characterizations",
					"properties",
					"material",
					"grade",
					"application",
					"order_type",
					"stages",
					"project_tags",
					"ingredients_category",
					"properties_category",
				],
			},
			headers
		)
		if (status === "Success") {
			resultData = { ...resultData, ...data }
			if (!!inputs?.length) {
				yield put(displayNamesSuccess({ ...resultData, language: lang }))
				return
			}
		}
	} catch (error) {
		yield put(displayNamesFailure())
	}

	try {
		const { data: { result: { data, status } } } = yield call(
			rustyDisplayNames,
			{ ...action.payload },
			headers
		)
		if (status === "Success") {
			resultData = { ...resultData, ...data }
		}
		else {
			ingredientsStatus = false
		}
	} catch (error) {
		ingredientsStatus = false
	}

	if (ingredientsStatus) {
		yield put(displayNamesSuccess({ ...resultData, language: lang, }))
	} else {
		let count = 0
		try {
			const {
				data: {
					result: { data, status },
				},
			} = yield call(getIngredientsCount, {}, headers)
			if (status === "Success") {
				count = data
			}
		} catch (error) {
			count = 0
		}

		const totalPages = Math.ceil(count / PAGE_SIZE)
		const tasks = []
		for (let i = 1; i <= totalPages; i++) {
			tasks.push(call(getDisplayNames, {
				...action.payload,
				page_size: PAGE_SIZE,
				page_num: i,
				inputs: ["ingredients"],
			}, headers))

		}
		try {
			const response = yield all(tasks)
			const ingredientsData: any = []
			response.forEach((res: any) => {
				const { data: { result: { data, status } } } = res
				if (status === "Success") {
					ingredientsData.push(...data?.ingredients)
				}
			})
			resultData["ingredients"] = ingredientsData
			yield put(displayNamesSuccess({ ...resultData, language: lang }))
		}
		catch (error) {
			yield put(displayNamesFailure())
		}
	}
}

function* filteredDisplayNamesSaga({ payload }: any): Generator<any, any, any> {
	try {
		const { defaultHeaders } = yield select((state) => state)
		const headers = { ...defaultHeaders, token: jwtManager.getToken() }
		const {
			data: {
				result: { data, status, message },
			},
		} = yield call(getFilterDisplayNamesApi, payload, headers)
		if (status === "Success") {
			yield put(filteredDisplayNamesSuccess(data))
		} else {
			yield put(filteredDisplayNamesFailure(message))
		}
	} catch (error) {
		yield put(filteredDisplayNamesFailure())
	}
}

export default function* rootSaga(): Generator<any, any, any> {
	yield takeLatest(displayNamesRequest, displayNamesSaga)
	yield takeLatest(filteredDisplayNamesRequest, filteredDisplayNamesSaga)
}
